import React from "react";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";
import { Card, Row, Col } from "antd";
import Layout from "../components/TheLayout";
import { HTMLContent } from "../components/Content";
import "../components/style/news.less";

const NewsPost = ({ data }) => {
  const { markdownRemark: post } = data;
  return (
    <Layout>
      <Helmet titleTemplate="OrgBioChem | News">
        <title>{`${post.frontmatter.title}`}</title>
      </Helmet>
      <Row>
        <Col md={{ span: 16, offset: 4 }}>
          <Card
            className="newsPost"
            bordered={false}
            actions={[<Link to="/">Back to home</Link>]}
          >
            <h2 className="title">{post.frontmatter.title}</h2>
            <p className="date">{post.frontmatter.date}</p>
            <HTMLContent content={post.html} />
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};

export default NewsPost;

export const pageQuery = graphql`
  query NewsPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "DD MMM YYYY")
        title
      }
    }
  }
`;
